<SidebarShell
  :logo="bolide_short_logo"
  brand_title="Bolide SOC"
  brand_subtitle="Enterprise Orchestrator"
  :initials="initials"
  :full_name="full_name"
  :is_admin="is_admin"
  @brand-click="backToGlobal"
>
  <!-- HEADER ACTIONS -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions" />
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      :main_label="active_property?.title"
      :sub_label="active_property?.description"
      :items="propertiesFormatted"
      :active_id="active_property?.id"
      :open="dropdownOpen"
      @toggle="toggleDropdown"
      @select="switchProperty"
    >
      <template #top>
        <div
          v-if="can_access_portfolio"
          class="sidebar-context-top border-bottom border-secondary pb-2 mb-2 cursor-pointer"
          @click="backToGlobal"
        >
          <p class="text-white fw-light text-xs mb-2">
            {{ entity_name }}
          </p>
          <p class="text-white-50 fw-light text-xxs mb-0">
            {{ entity_subtitle }}
          </p>
        </div>
      </template>
    </SidebarContext>
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="sidebar-menu px-3 mt-3 w-100">
      <!-- DYNAMIC MENU ITEMS -->
      <div
        v-for="item in menuItems"
        :key="item.key"
        class="sidebar-menu-item d-flex align-items-center py-2 ps-2 rounded w-100"
        :class="[
          item.disabled
            ? 'pe-none text-white-50 opacity-50'
            : 'cursor-pointer',
          active_menu_item === item.key && !item.disabled
            ? 'bg-surface text-white border-start border-3 border-active'
            : 'text-white-50 hover-bg-surface'
        ]"
        :aria-label="item.label"
        :aria-disabled="item.disabled ? 'true' : 'false'"
        @click="!item.disabled && selectPropertyMenuItem(item.key)"
      >
        <!-- CUSTOM LOGO -->
        <template v-if="item.icon === 'custom'">
          <img
            :src="item.logo"
            :alt="item.label"
            class="sidebar-menu-icon sidebar-logo-icon me-2"
            :class="{ 'cursor-pointer': !item.disabled }"
          />
        </template>

        <!-- NORMAL ICON -->
        <template v-else>
          <i
            :class="[
              item.icon,
              'sidebar-menu-icon',
              'me-2',
              !item.disabled ? 'cursor-pointer' : '',
              active_menu_item === item.key ? 'text-white' : 'text-white-50'
            ]"
            :aria-label="item.label"
          ></i>
        </template>

        <!-- LABEL -->
        <p
          class="sidebar-menu-label sidebar-menu-text fw-semibold text-xs mb-0"
          :class="{ 'cursor-pointer': !item.disabled }"
        >
          {{ item.label }}
        </p>
      </div>
    </div>
  </template>

  <!-- ✅ AFTER MENU (NOW LEGAL) -->
  <template #after-menu>
    <div class="sidebar-after-menu px-3 mt-4">
      <hr class="border-secondary opacity-50 mb-2" />

      <p class="sidebar-after-menu-title text-white-50 text-xxs mb-2">
        AUTOMATION (Future)
      </p>

      <div
        class="sidebar-after-menu-item d-flex align-items-center justify-content-between ps-3 mb-2 pe-none"
        aria-label="Voice Dial & Tasks"
      >
        <div class="sidebar-after-menu-copy d-flex align-items-center">
          <i class="bi bi-arrow-return-right text-white-50 me-2"></i>
          <p class="sidebar-after-menu-text text-white-50 text-xs mb-0">
            Voice Dial &amp; Tasks
          </p>
        </div>

        <span class="sidebar-after-menu-badge badge bg-active text-on-active fw-bold rounded-pill px-2 py-1 text-xxs">
          BETA
        </span>
      </div>
    </div>
  </template>
</SidebarShell>
